module.exports = __webpack_public_path__ + "img/default.032cb3af.png";